import { isApiErrors } from '../../models/ApiErrors'

export const readApiMessage = (error: unknown, fallback: string): string => {
  const body = typeof error === 'object' && error !== null && 'data' in error ? error.data : null
  if (isApiErrors(body) && body.errors.length > 0) {
    return body.errors.map((error) => error.message).join(' ')
  }
  return fallback
}
